import $ from 'jquery';
import debounce from './debounce';
import validateImageMinSize from './validateImageMinSize';
import validateMaxWidthHeight from './validateMaxWidthHeight';
import validateFileMaxSize from './validateFileMaxSize';

export default (options) => {
  $.widget('blueimp.fileupload', $.blueimp.fileupload, {
    processActions: {
      debounce(data) {
        return debounce(this, data);
      },

      validateImageMinSize(data) {
        return validateImageMinSize(this, data, options);
      },

      validateMaxWidthHeight(data) {
        return validateMaxWidthHeight(this, data, options);
      },

      validateFileMaxSize(data) {
        return validateFileMaxSize(this, data);
      },
    },
  });
};
